import { bundles as importBundles } from './bundles-gentux';
export const bundles = importBundles;
